import { colorPalette } from "../../shared/utils/constants";

export const customStyles = {
  heroSection: {
    backgroundColor: colorPalette.headerBackground,
    color: colorPalette.white,
    py: 8,
    mt: 15,
    textAlign: "center",
  },
  heroTitle: {
    fontFamily: "'Bebas Neue', sans-serif",
    fontSize: { xs: "2.5rem", md: "3.5rem" },
    // fontWeight: 700,
    mb: 2,
  },
  heroSubtitle: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 300,
    maxWidth: 700,
    mx: "auto",
    opacity: 0.9,
  },
  contentContainer: {
    py: 8,
  },
  formCard: {
    p: 4,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    borderRadius: 2,
    // height: "100%",
  },
  sectionTitle: {
    fontFamily: "'Bebas Neue', sans-serif",
    color: colorPalette.sectionTitle,
    fontSize: { xs: "1.8rem", md: "2.2rem" },
    // fontWeight: 600,
  },
  formLabel: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 500,
    fontSize: "0.95rem",
    mb: 0.5,
    color: colorPalette.black,
  },
  submitButton: {
    backgroundColor: colorPalette.headerBackground,
    color: colorPalette.white,
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 600,
    fontSize: "1.1rem",
    py: 1.5,
    borderRadius: 1,
    textTransform: "none",
    "&:hover": {
      backgroundColor: colorPalette.sectionTitle,
    },
  },
  infoCard: {
    p: 3,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    borderRadius: 2,
  },
  socialCard: {
    p: 3,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    borderRadius: 2,
    background: `linear-gradient(135deg, ${colorPalette.headerBackground}15 0%, ${colorPalette.sectionTitle}15 100%)`,
  },
  infoCardTitle: {
    fontFamily: "'Bebas Neue', sans-serif",
    color: colorPalette.sectionTitle,
    fontSize: "1.5rem",
    // fontWeight: 600,
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
  },
  iconWrapper: {
    backgroundColor: `${colorPalette.headerBackground}20`,
    borderRadius: "50%",
    p: 1.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contactIcon: {
    color: colorPalette.headerBackground,
    fontSize: "1.5rem",
  },
  contactLabel: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 600,
    fontSize: "0.9rem",
    color: colorPalette.black,
    mb: 0.5,
  },
  contactValue: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    fontSize: "0.95rem",
    color: "text.secondary",
    lineHeight: 1.6,
  },
  contactLink: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    fontSize: "0.95rem",
    color: colorPalette.headerBackground,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  socialButton: {
    borderColor: colorPalette.headerBackground,
    color: colorPalette.headerBackground,
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 700,
    textTransform: "none",
    py: 1.2,
    fontSize: "1rem",
    "&:hover": {
      borderColor: colorPalette.sectionTitle,
      backgroundColor: `${colorPalette.headerBackground}10`,
    },
  },
  hoursRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dayText: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 500,
    fontSize: "0.95rem",
    color: colorPalette.black,
  },
  timeText: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    fontSize: "0.9rem",
    color: "text.secondary",
  },
};
